import { io } from 'socket.io-client'
import config from 'src/config'

let socket
let url = config.apiGateway.EXPRESS_URL
let newurl = url.replace('/api/v1/', '')
const useSocket = userId => {
  if (!socket && userId) {
    try {
      socket = io(newurl, {
        query: { userId },
        transports: ['websocket'],
        timeout: 5000,
        reconnection: false, // Disable reconnection to avoid repeated errors
      })

      // Handle connection errors gracefully
      socket.on('connect_error', error => {
        console.warn(
          "WebSocket connection failed (this is normal if the backend doesn't support Socket.IO):",
          error.message,
        )
      })

      socket.on('disconnect', reason => {
        console.log('WebSocket disconnected:', reason)
      })
    } catch (error) {
      console.warn('Failed to initialize WebSocket:', error.message)
      return null
    }
  }

  return socket
}

export default useSocket
